import { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db } from './firebase';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';

export default function Leaderboard({ onClose }) {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('humans');
  const [humanWins, setHumanWins] = useState([]);
  const [botWins, setBotWins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      setLoading(true);
      try {
        // Top wins vs humans
        const humanQuery = query(
          collection(db, 'users'),
          orderBy('stats.wins', 'desc'),
          limit(10)
        );
        const humanSnap = await getDocs(humanQuery);
        setHumanWins(humanSnap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(p => (p.stats?.wins || 0) > 0)
        );

        // Top wins vs bots
        const botQuery = query(
          collection(db, 'users'),
          orderBy('stats.botWins', 'desc'),
          limit(10)
        );
        const botSnap = await getDocs(botQuery);
        setBotWins(botSnap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(p => (p.stats?.botWins || 0) > 0)
        );
      } catch (err) {
        console.error('Leaderboard error:', err);
      }
      setLoading(false);
    };
    fetchLeaderboard();
  }, []);

  const tabs = [
    { id: 'humans', label: '👥 vs Humans' },
    { id: 'bots', label: '🤖 vs Computer' },
  ];

  const renderRow = (player, rank, tab) => {
    const isMe = player.id === user?.uid;
    const wins = tab === 'humans' ? player.stats?.wins || 0 : player.stats?.botWins || 0;
    const games = tab === 'humans' ? player.stats?.gamesPlayed || 0 : player.stats?.botGamesPlayed || 0;
    const winRate = games > 0 ? Math.round((wins / games) * 100) : 0;
    const medals = ['🥇', '🥈', '🥉'];

    return (
      <div key={player.id} style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '10px 12px', borderRadius: 8, marginBottom: 6,
        background: isMe ? '#E1F5EE' : '#f9f9f9',
        border: isMe ? '1px solid #1D9E75' : '1px solid #f0f0f0',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 16, minWidth: 28 }}>{medals[rank] || `${rank + 1}.`}</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500 }}>
              {player.displayName || 'Player'}
              {isMe && <span style={{ fontSize: 11, color: '#0F6E56', marginLeft: 6 }}>(you)</span>}
            </div>
            <div style={{ fontSize: 11, color: '#888' }}>{games} games • {winRate}% win rate</div>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 14, fontWeight: 500, color: '#1D9E75' }}>{wins} wins</div>
        </div>
      </div>
    );
  };

  const data = activeTab === 'humans' ? humanWins : botWins;

  return (
    <div style={{ padding: '1rem', fontFamily: 'sans-serif', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 500, margin: 0 }}>🏆 Leaderboard</h2>
        {onClose && <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#888' }}>✕</button>}
      </div>

      <div style={{ display: 'flex', gap: 4, background: '#f0f0f0', borderRadius: 8, padding: 4, marginBottom: 16 }}>
        {tabs.map(tab => (
          <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
            flex: 1, padding: 8, fontSize: 13, border: activeTab === tab.id ? '0.5px solid #ddd' : 'none',
            borderRadius: 6, cursor: 'pointer',
            background: activeTab === tab.id ? '#fff' : 'none',
            fontWeight: activeTab === tab.id ? 500 : 400,
            color: activeTab === tab.id ? '#000' : '#666',
          }}>{tab.label}</button>
        ))}
      </div>

      <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginBottom: 16, lineHeight: 1.6 }}>
        {activeTab === 'humans'
          ? 'Rankings based on wins against human players only.'
          : 'Rankings based on wins against computer bots.'}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#888', fontSize: 14 }}>Loading...</div>
      ) : data.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#888', fontSize: 14 }}>
          No players yet — be the first! 🎮
        </div>
      ) : (
        <div>
          <div style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}>
            Global — Top 10
          </div>
          {data.map((player, i) => renderRow(player, i, activeTab))}
        </div>
      )}
    </div>
  );
}
